import React from 'react'
import './SksTasksSmallCard.scss'
import {
  MdSecurity,
  MdSpeaker,
  MdLocalFireDepartment,
  MdNotificationsActive,
  MdLan,
  MdVideoCall,
  MdTv,
  MdTranslate,
  MdCheckCircle,
} from 'react-icons/md'

// Имя иконки приходит из данных секции — так проще держать их рядом с текстом.
const ICONS = {
  MdSecurity,
  MdSpeaker,
  MdLocalFireDepartment,
  MdNotificationsActive,
  MdLan,
  MdVideoCall,
  MdTv,
  MdTranslate,
}

const SksTasksSmallCard = ({ icon, title, subTitle, wide }) => {
  const Icon = ICONS[icon] || MdCheckCircle

  return (
    <div className={'sksTasksSmallCard_block' + (wide ? ' sksTasksSmallCard_block--wide' : '')}>
      <span className="sksTasksSmallCard_icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="sksTasksSmallCard_text">
        <h3>{title}</h3>
        <p>{subTitle}</p>
      </div>
    </div>
  )
}

export default SksTasksSmallCard
